import PythonApi from "@/services/PythonApi";

export default {
    list(payload) {
        const url = "report", params = new URLSearchParams();
        if (payload) {
            if (payload.fromDate)
                params.append('from_date', payload.fromDate);
            if (payload.toDate)
                params.append('to_date', payload.toDate);
            if (payload.cow_ids && payload.cow_ids.length > 0)
                payload.cow_ids.forEach(cow_id => params.append('cow_ids', cow_id));
            if (payload.bolus_ids && payload.bolus_ids.length > 0)
                payload.bolus_ids.forEach(bolus_id => params.append('bolus_ids', bolus_id));
            if (payload.report_type)
                params.append('report_type', payload.report_type);
        }
        return PythonApi().get(url, params);
    },
}


// WEBPACK FOOTER //
// ./src/api/report-api.js